/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'Social/Twitter': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<path pid="0" fill-rule="evenodd" d="M22 6.063c-.787.318-1.575.635-2.362.635.787-.476 1.575-1.27 1.89-2.38-.788.476-1.733.793-2.678.952C18.063 4.476 16.96 4 15.858 4c-2.204 0-4.094 1.905-4.094 4.127 0 .317 0 .635.157.952-3.464-.158-6.456-1.904-8.504-4.285-.315.635-.63 1.27-.63 2.063 0 1.429.788 2.699 1.89 3.492-.63 0-1.26-.159-1.89-.476 0 2.064 1.418 3.65 3.307 4.127-.314.159-.787.159-1.102.159h-.787c.472 1.587 2.047 2.857 3.937 2.857-1.418 1.111-3.15 1.746-5.197 1.746H2c1.89 1.111 3.937 1.905 6.3 1.905 7.558 0 11.81-6.35 11.81-11.905v-.476c.63-.635 1.26-1.27 1.89-2.223z"/>'
  }
})
